import { render } from "./Column.vue?vue&type=template&id=79d8471a&scoped=true"
const script = {}

import "./Column.vue?vue&type=style&index=0&id=79d8471a&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79d8471a"]])

export default __exports__